import { Card } from "@/components/ui/card";
import { useIdioma } from "@/context/IdiomaContext";

const COLORES = { positivo: "#EC1E79", neutro: "#F5C542", atencion: "#7C5CFF" };
const CLAVES = {
  positivo: "portal.bienestarPositivo",
  neutro: "portal.bienestarNeutro",
  atencion: "portal.bienestarAtencion",
};

/** Dona del reparto emocional del último mes (orientativo). */
export const BienestarEmocional = ({ bienestar }) => {
  const { t } = useIdioma();

  if (!bienestar || !bienestar.total) {
    return (
      <Card className="rounded-2xl p-6 border-border shadow-sm" data-testid="bienestar-vacio">
        <p className="font-display text-lg font-bold flex items-center gap-2">
          <span className="text-primary">♥</span> {t("portal.bienestar")}
        </p>
        <p className="text-sm text-muted-foreground mt-3">{t("portal.bienestarVacio")}</p>
      </Card>
    );
  }

  const radio = 70;
  const circunferencia = 2 * Math.PI * radio;
  let acumulado = 0;

  return (
    <Card className="rounded-2xl p-6 border-border shadow-sm" data-testid="bienestar-emocional">
      <p className="font-display text-lg font-bold flex items-center gap-2">
        <span className="text-primary">♥</span> {t("portal.bienestar")}
      </p>
      <div className="flex justify-center mt-6">
        <svg width="190" height="190" viewBox="0 0 190 190" role="img" aria-label={t("portal.bienestar")}>
          {bienestar.reparto.filter((r) => r.total > 0).map((r) => {
            const largo = (r.porcentaje / 100) * circunferencia;
            const offset = circunferencia - acumulado;
            acumulado += largo;
            return (
              <circle key={r.key} cx="95" cy="95" r={radio} fill="none"
                stroke={COLORES[r.key]} strokeWidth={26}
                strokeDasharray={`${largo} ${circunferencia - largo}`}
                strokeDashoffset={offset} transform="rotate(-90 95 95)"
                data-testid={`bienestar-arco-${r.key}`} />
            );
          })}
          <text x="95" y="103" textAnchor="middle" fontSize="34">☺</text>
        </svg>
      </div>
      <div className="mt-6 space-y-2">
        {bienestar.reparto.map((r) => (
          <div key={r.key} className="flex items-center gap-3 text-sm" data-testid={`bienestar-item-${r.key}`}>
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORES[r.key] }} />
            <span className="font-semibold">{r.porcentaje}%</span>
            <span className="text-muted-foreground">{t(CLAVES[r.key])}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-5">
        {t("portal.bienestarNota")}
        {bienestar.ultima_actualizacion ? ` ${bienestar.ultima_actualizacion}.` : ""}
      </p>
    </Card>
  );
};
